import React from 'react'
import {
  List,
  Typography,
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails,
} from '@mui/material'
import { makeStyles, withStyles } from 'tss-react/mui'
import { ExpandMore } from '@mui/icons-material'
import { AccordionList as AccordionListType } from '../../types/heroTextSection'
import RichText from '../RichText'

interface AccordionListProps {
  list: AccordionListType
}

export const AccordionList: React.FC<AccordionListProps> = ({ list }) => {
  const { classes } = useStyles()

  return (
    <List className={classes.list}>
      {list.accordionItemArray.map((item) => (
        <Accordion
          key={item.contentful_id}
          data-contentful-id={item.contentful_id}
          itemScope
        >
          <AccordionSummary
            itemProp="name"
            expandIcon={<ExpandMore className={classes.expandIconWrapper} />}
          >
            <Typography variant="body1" className={classes.title}>
              {item.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div itemProp="text">
              <RichText
                rawBody={item.body.raw}
                references={item.body.references}
              />
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
    </List>
  )
}

const Accordion = withStyles(MuiAccordion, (theme) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderTop: `1px solid transparent`,
    backgroundColor: 'transparent',
    '&:first-child': {
      borderRadius: 0,
      borderTopColor: `${theme.palette.divider}`,
    },
    '&:last-child': {
      borderRadius: 0,
    },
    '&::before': {
      backgroundColor: 'transparent',
    },
  },
  expanded: {
    '&&': {
      margin: 0,
    },
  },
}))

const AccordionSummary = withStyles(MuiAccordionSummary, (theme) => ({
  root: {
    paddingTop: '1.53125rem',
    paddingBottom: '1.46875rem',
    paddingLeft: 0,
    flexDirection: 'row-reverse',
    '&.Mui-expanded': {
      paddingBottom: 0,
      [theme.breakpoints.down('md')]: {
        paddingBottom: '.75rem',
      },
    },

    '&:focus': {
      outline: 0,
    },
  },
  content: {
    marginTop: 0,
    marginBottom: 0,
  },
  expanded: {
    '&&': {
      minHeight: 0,
      margin: 0,
      padding: '.5rem 0 0 0.75rem',
      marginLeft: '-0.35rem',
    },
  },
  expandIconWrapper: {
    '&&': {
      paddingLeft: 0,
      paddingTop: 0,
      paddingBottom: 0,
      marginRight: '-.5rem',
    },
  },
}))

const AccordionDetails = withStyles(MuiAccordionDetails, () => ({
  root: {
    paddingLeft: '1.5rem',
  },
}))

const useStyles = makeStyles()((theme) => ({
  list: {
    margin: '1.4375rem 0',
  },
  title: {
    color: theme.palette.action.hover,
    fontWeight: 'bold',
    marginLeft: '0.5rem',
  },
  expandIconWrapper: {
    fontSize: '.8em',
    color: theme.palette.divider,
  },
}))

export default AccordionList
